import React from "react";
import Field from "./Field";
import SwitchControl from "./SwitchControl";
import { FieldProps } from "./Types";

const SwitchField: React.FC<FieldProps> = ({ labelProps, controlProps, visible, disabled }) => {

    if (visible === false)
        return <></>;

    return (
        <Field {...labelProps}>
            <SwitchControl {...controlProps} disabled={disabled} />
        </Field>
    );
}
export default SwitchField;